export default "__VITE_ASSET__CZxXeD1h__"